"use client";
import React, { useState } from "react";
import styles from "./Accordion.module.scss";
import cn from "clsx";
import ArrowSVG from "@/SvgIcons/ArrowDown";

const Accordion = ({ data }: { data: any }) => {
  const [openSection, setOpenSection] = useState<number | null>(0);

  const toggleSection = (index: number | null) => {
    if (openSection === index) {
      setOpenSection(null);
    } else {
      setOpenSection(index);
    }
  };

  return (
    <div id='accordion' >
      {data?.List?.map((item: any, index: number) => (
        <div
          key={item.id}
          className={cn(styles.accordionitem, {
            [styles.opened]: openSection === index,
          })}
        >
          {/* Accordion Header */}
          <div
            className={cn("cursor-pointer flex justify-between items-center")}
            onClick={() => toggleSection(index)}
          >
            <h3 className={cn(styles.accordionTitle, "text-primary-blue")} dangerouslySetInnerHTML={{
              __html: item.Question,
            }} />
            <span className={styles.icon}>
              <ArrowSVG
                rotate={openSection === index ? 180 : 0}
                width={16}
                height={16}
                isActive={openSection === index}
                color="blue"
              />
            </span>
          </div>

          {/* Accordion Content */}
          {openSection === index && (
            <div className={cn(styles.accordionBody, "mt-4")} dangerouslySetInnerHTML={{
              __html: item.Answer,
            }}
            />
             
            
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
